import { AwesomeGraphQLClient, gql as _gql } from 'awesome-graphql-client'
import mergeOptions from 'merge-options'

AwesomeGraphQLClient.prototype._request
    = AwesomeGraphQLClient.prototype.request

AwesomeGraphQLClient.prototype.request = function (
    query,
    variables = {},
    fetchOptions = {}
) {
    return this._request(query, variables, mergeOptions(
        this.getFetchOptions() || {}, fetchOptions || {}))
}

AwesomeGraphQLClient.prototype._requestSafe
    = AwesomeGraphQLClient.prototype.requestSafe

AwesomeGraphQLClient.prototype.requestSafe = function (
    query,
    variables = {},
    fetchOptions = {}
) {
    return this._requestSafe(query, variables, mergeOptions(
        this.getFetchOptions() || {}, fetchOptions || {}))
}

export const graphqlClient = new AwesomeGraphQLClient({
    endpoint: '/v1/graphql',
    fetchOptions: {
        headers: {
            'x-hasura-role': 'anonymous'
        }
    }
})

export const gql = _gql